var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActiveRankings = function SvgActiveRankings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.429,
    height: 11.2,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.027%",
    y1: "-4.972%",
    x2: "88.304%",
    y2: "101.293%",
    id: "ActiveRankings_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA88",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.286 6.3c0-.387.314-.7.703-.7h3.513v7H1.286V6.3Zm5.143-4.2c0-.387.287-.7.642-.7h3.858c.355 0 .642.313.642.7v10.5H6.43V2.1ZM12.5 12.6V8.4h3.548c.368 0 .666.313.666.7v3.5H12.5Z",
    transform: "translate(-1.286 -1.4)",
    fill: "url(#ActiveRankings_svg__a)",
    fillRule: "evenodd"
  })));
};
export default SvgActiveRankings;